module.exports = __webpack_public_path__ + "static/img/sup_logo_5.3af23720.png";